import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { DE_TRANSLATE } from "@/data/de-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/de/translate";
const C = DE_TRANSLATE;

export const Route = createFileRoute("/de/translate")({
  head: () => ({
    meta: [
      { title: ctaTitle("Beeidigte Übersetzung DE↔TH in Bangkok | NYC Legal", "/de/translate", "th")},
      { name: "description", content: ctaDesc("Vom MFA, der Immigration, DBD und Botschaften anerkannte Übersetzungen. MOJ-Übersetzer. 1–3 Werktage. Ask us anything — real experts reply within minutes.", "/de/translate", "th")},
      { property: "og:title", content: ctaTitle("Beeidigte Übersetzung DE↔TH | NYC Legal", "/de/translate", "th")},
      { property: "og:description", content: ctaDesc("DE↔TH↔EN mit MOJ-Stempel. Apostille im Paket.", "/de/translate", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "de_DE" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/translate" },
          { hreflang: "en", path: "/en/translate" },
          { hreflang: "zh", path: "/zh/translate" },
          { hreflang: "ja", path: "/ja/translate" },
          { hreflang: "ko", path: "/ko/translate" },
          { hreflang: "ru", path: "/ru/translate" },
          { hreflang: "de", path: "/de/translate" },
          { hreflang: "x-default", path: "/translate" },
        ],
        "/translate",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "ProfessionalService",
        name: "NYC Legal — Certified Translation (DE)", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "DE", "AT", "CH"], inLanguage: "de",
        priceRange: "฿500–฿3,000",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "de",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: `${SEO_SITE}/de` },
          { "@type": "ListItem", position: 2, name: "Übersetzung", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
